import { makeStyles } from "tss-react/mui"
import { Box, CircularProgress, Grid } from "@mui/material"

const useStyles = makeStyles()((theme) => ({
    wrap: {
        margin: "15rem 0",
    },
    fullPage: {
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        // an overlay: what is rendered under it stays clickable
        pointerEvents: "none",
    },
}))

type LoadingSpinnerProps = Readonly<{
    className?: string
    fullPage?: boolean
}>

export function LoadingSpinner({ className, fullPage = false }: LoadingSpinnerProps) {
    const { classes, cx } = useStyles()

    if (fullPage) {
        return (
            <Box display="flex" alignItems="center" justifyContent="center" className={cx(classes.fullPage, className)}>
                <CircularProgress />
            </Box>
        )
    }

    return (
        <Grid container justifyContent="center" className={cx(classes.wrap, className)}>
            <CircularProgress size={70} />
        </Grid>
    )
}
